export const AUTH_MESSAGE = Object.freeze({
  LOG_IN: 'LOG_IN',
  LOG_OUT: 'LOG_OUT',
});

export const DEFAULT_TIMEOUT_MS = 5000;
